<template>
    <!-- 1.all-container-start -->
    <div class="all-container flexStyle1">
        <div class="main flexStyle1">
            <div class="left">
                <img v-if="web_logo" :src="web_logo" :alt="web_name" class="img">
                <img v-else src="../../images/m-logo.png" class="img">
            </div>
            <div class="middle flexStyle2">
                <div @click="handleUserClickedTabbar(index)" :class="index==tabbarIndex?'item item-on flexStyle1':'item flexStyle1'" v-for="(item, index) of 5" :key="index">
                    <span class="hands oneLine" v-if="index===0">礼品兑换</span>
                    <span class="hands oneLine" v-else-if="index===1">订单查询</span>
                    <span class="hands oneLine" v-else-if="index===2">兑换流程</span>
                    <span class="hands oneLine" v-else-if="index===3">公告通知</span>
                </div>
            </div>
            <!-- <div class="right oneLine">{{web_title}}</div> -->
        </div>
        
    </div>
    <!-- 1.all-container-end -->
</template>

<script>
export default {
    data(){                                         // 1.data
        return {
            web_title: '',                          // 1.1.网站标题
            web_logo: '',                           // 1.2.网站logo
            web_name: '',                           // 1.3.网站logo名称
            web_top_imgurl: '',                     // pc顶部图片链接
            web_top_linkurl: '',                    // pc顶部跳转链接
        }
    },

    methods: {                                      // 2.methods              
        handleUserClickedTabbar(index){             // 2.1.用户点击tabbar按键
            if (index!=this.tabbarIndex){
                //this.tabbarIndex = index;
                this.tabbarPageChange(index);
            }
        },

        tabbarPageChange(index){                    // 2.2.tabbar页面切换方法
            switch(index){
                case 0:
                    this.$router.push('/home');
                    break
                case 1:
                    this.$router.push('/orderFind');
                    break
                case 2:
                    this.$router.push('/helpCenter'); 
                    break
                case 3:
                    this.$router.push('/giftsExchange');
                    break
            }
        }
    },

    props: {                                        // 3.props
        tabbarIndex: {                              // 3.1.tabbarIndex
            type: Number,
            default: 0
        },
    },

    mounted(){                                      // 4.mounted
        this.web_title = localStorage.web_title || '';
        this.web_logo = localStorage.web_logo || '';
        this.web_name = localStorage.web_name || '';
        this.web_top_imgurl = localStorage.web_top_imgurl || '';
        this.web_top_linkurl = localStorage.web_top_linkurl || '';
    }
}
</script>

<style lang="scss" scoped>
@import './tabbar.scss';
</style>
